import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Button} from '@chekinapp/ui';

export const ConfirmButton = styled(Button)`
  margin: 0 auto;
  width: 100%;
  min-width: 0;

  @media (min-width: ${DEVICE.mobileM}) {
    width: 327px;
  }
`;

export const SecondaryButton = styled(Button)``;
